interface QuoteListSkeletonProps {
    rowCount?: number;
    statusCount?: number;
}

const QuoteListSkeleton = ( {
    rowCount = 10,
    statusCount = 9,
}: QuoteListSkeletonProps ) => {
    return (
        <div className="space-y-6 mt-6">
            { /* Status Tabs */ }
            <div className="flex flex-wrap gap-3 border-b pb-4">
                { [ ...Array( statusCount ) ].map( ( _, index ) => (
                    <div
                        key={ index }
                        className="flex items-center gap-1 px-1 py-1 rounded-full bg-gray-100 animate-pulse"
                    >
                        <div className="h-4 w-12 bg-gray-200 rounded-full"></div>
                        <div className="h-4 w-6 bg-gray-300 rounded-full"></div>
                    </div>
                ) ) }
            </div>

            { /* Filter Row */ }
            <div className="flex items-center gap-3">
                <div className="h-9 w-64 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-9 w-40 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-9 w-24 bg-gray-300 rounded animate-pulse"></div>
                <div className="h-9 w-24 bg-gray-100 rounded animate-pulse"></div>
            </div>

            { /* Table */ }
            <div className="bg-white border rounded-lg overflow-hidden">
                <table className="w-full dataviews-view-table">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="py-4 px-6 text-left">
                                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="py-4 px-6 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="py-4 px-6 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="py-4 px-6 text-left">
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                            <th className="py-4 px-6 text-left">
                                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { [ ...Array( rowCount ) ].map( ( _, index ) => (
                            <tr key={ index } className="border-t">
                                <td className="py-4 px-6">
                                    <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="py-4 px-6">
                                    <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="py-4 px-6">
                                    <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                                </td>
                                <td className="py-4 px-6">
                                    <div className="h-6 w-20 bg-gray-100 rounded-full animate-pulse"></div>
                                </td>
                                <td className="py-4 px-6 flex gap-3">
                                    <div className="h-4 w-10 bg-gray-200 rounded animate-pulse"></div>
                                    <div className="h-4 w-10 bg-gray-300 rounded animate-pulse"></div>
                                </td>
                            </tr>
                        ) ) }
                    </tbody>
                </table>
                { /* Pagination */ }
                <div className="px-6 py-4 flex items-center justify-between border-t bg-white">
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-4 w-8 bg-gray-200 rounded animate-pulse mx-2"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteListSkeleton;
